import { ApiService } from "../../../../../core";
import { AuthLoginRepository, LoginResponse } from "../../core";

export class AuthLoginRepositoryImpl implements AuthLoginRepository {
    private api;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async login(token: string): Promise<LoginResponse> {
        try {
            const responseLoginJson: LoginResponse = await this.api.post("/login", token);
            return responseLoginJson;
        } catch (error) {
            console.error(error)
            return { success: false, response: error.message }
        }
    }
}